import React from 'react';
import classNames from 'classnames';
import { SvgIcon } from 'seduo-ui';
const StudyPlanButton = ({ onAddToStudyPlan, onRemoveFromStudyPlan, active, className, title, large, }) => (<button onClick={() => {
        if (active) {
            onRemoveFromStudyPlan();
            return;
        }
        onAddToStudyPlan();
        return;
    }} title={title} className={classNames('study-plan-button', { 'study-plan-button--large': large }, { 'study-plan-button--active': active }, className)}>
        <SvgIcon kind="Bookmark" className="study-plan-button__icon"/>
    </button>);
StudyPlanButton.defaultProps = {
    active: false,
    large: false,
};
export default StudyPlanButton;
